import { assign, fromPromise, setup } from 'xstate';
import { showAxiosErrorAction } from '~/features/actions';
import { loadingFalse, loadingTrue, setData, setProviderIdFromEvent } from './actions';
import { ACADEMICS_API_CALLS } from './api';
import { Events } from './events';
import { Context, Scope } from './types';

export const eduTrainingMachine = setup({
  actors: {
    getData: fromPromise(ACADEMICS_API_CALLS.get),
  },
  types: {
    context: {} as Context,
    events: {} as Events,
    input: {} as Partial<Context>,
  },
  actions: {
    loadingTrue: assign(loadingTrue),
    loadingFalse: assign(loadingFalse),
    setData: assign(setData),
    setProviderIdFromEvent: assign(setProviderIdFromEvent),
    sendError: showAxiosErrorAction,
  },
}).createMachine({
  context: ({ input }) => ({
    loading: false,
    error: false,
    providerId: input.providerId || 0,
    pagination: input.pagination || {
      page: 1,
      pageSize: 10,
      total: 0,
    },
    modal: input.modal || {
      edit: false,
      create: false,
    },
    form: input.form || {},
    data: input.data || [],
    idToDelete: input.idToDelete || 0,
    sort: input.sort || {
      degreeName: -1,
      gradDate: -1,
      id: 1,
      schoolName: -1,
      sortBy: 'id' as const,
    },
  }),
  initial: '$_IDLE',
  on: {
    ON_LOAD: {
      target: '.$_GET',
      actions: ['setProviderIdFromEvent', 'loadingTrue'],
    },
  },
  states: {
    $_IDLE: {},
    $_VIEW: {},
    $_GET: {
      invoke: {
        id: 'getData',
        src: 'getData',
        input: ({ context, event }) => ({ context, event }) as Scope,
        onDone: {
          target: '$_VIEW',
          actions: ['setData', 'loadingFalse', assign({ error: false })],
        },
        onError: {
          target: '$_VIEW',
          actions: ['sendError', 'loadingFalse', assign({ error: true })],
        },
      },
    },
  },
});
